<template>
  <v-row justify="center">
    <v-dialog
    v-model="deleteCompanionDialog"
    :persistent='true'
    width="70%"
    height="100%"
    class="modalDialog"
    no-click-animation
    >
      <div class="memberAdd">
        <v-card class="cardWrap">
          <CardTitle title="来場登録" />
          <div>
            <span style="color: red;">
              ※予約人数は入力されたプレーヤー数で変更されます。<br>
                削除する組の「組を削除」にチェックしてください。
            </span>
          </div>
          <div>
            <div v-for="(frame, index) in companionRegist" :key="frame.id" class='margin_buttom20'>
              <div class="frame_name">
                <span class='space fontsize-1_5rem'>{{ frame.id }}組目</span>
                <span class='space fontsize-1_5rem'>{{ frame.course_name }}</span>
                <span class='space fontsize-1_5rem'>{{ frame.time }}</span>
                <span class="d-flex">
                  <v-checkbox
                    label="組を削除"
                    class="col-3"
                    v-bind:false-value="''"
                    v-bind:true-value="frame.cell_id"
                    @change="selectDeleteCell(frame.cell_id)"
                  />
                  <v-checkbox
                    v-if="index == 0"
                    class="col-9"
                    label="予約内容をメールで送信"
                    v-model="sendFlag"
                  />
                </span>
              </div>
              <v-data-table
              :headers="headers"
              :items="frame.players"
              class="golfGroupTbody"
              hide-default-footer
              >
                <template v-slot:item.family_name="{ item }">
                  <v-text-field
                  item-value="code"
                  item-text="name"
                  v-model.trim="item.family_name"
                  :disabled="item.disableFlag"/>
                </template>
                <template v-slot:item.given_name="{ item }">
                  <v-text-field
                  item-value="code"
                  item-text="name"
                  v-model.trim="item.given_name"
                  :disabled="item.disableFlag"/>
                </template>
                <template v-slot:item.email="{ item }">
                  <v-text-field
                  item-value="code"
                  item-text="name"
                  @blur="GetEmailSearchMemberClass(frame.id,item.id,item.email)"
                  v-model.trim="item.email"
                  :disabled="item.disableFlag"/>
                </template>
                <template v-slot:item.mobile_number="{ item }">
                <v-text-field
                    item-value="code"
                    item-text="name"
                    v-model.trim="item.mobile_number"
                    :disabled="item.disableFlag"
                    />
                </template>
                <template v-slot:item.member_class="{ item }">
                  <v-select
                  :items="memberClassSelectItem"
                  item-value="code"
                  item-text="code_name"
                  v-model="item.member_class"
                  :disabled="item.disableFlag"/>
                </template>
                <template v-slot:item.visited_code="{ item }">
                  <v-select
                  :items="visitorClassSelectItem"
                  item-value="code"
                  item-text="name"
                  v-model="item.visited_code"
                  :disabled="item.visitedDisableFlag"/>
                </template>
                <template v-slot:item.Btn="{ item }">
                  <v-btn
                  color="green darken-4" text
                  @click="PushClearButton(frame.id,item.id,item.email)"
                  class="editBtn">クリア
                  </v-btn>
                </template>
              </v-data-table>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-4" text @click="CloseDialog">閉じる</v-btn>
              <v-btn color="green darken-4" text @click="MakeUpdateCompanionList">変更</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </div>
      <ChangeOverlay
        page-name="来場者"
        @processing="UpdateCompanion"
        @cancel="changeOverlay = !changeOverlay"
        :process-result="process"
        :OverlaySwitch="changeOverlay"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import ChangeOverlay from '@/views/Master/page/overlay/ChangeOverlay';
import { CODE_MASTER } from '../../config';
import { GET_COMPANION_LIST, UPDATE_COMPANION } from '../../../constants/companion';
import { GET_CODE_KEY_LIST } from '@/constants/codelist';
import { GET_EMAIL_SEARCH_MEMBER_CLASS, GET_MEMBER_PROFILE } from '../../../constants/member';
import { REGIST_RESERVE_DELETE_CELL, GET_RESERVE_TYPE, COMPLETE_RESERVE_EMAIL } from '../../../constants/reserve';
import validater from '../../../lib/validater';

export default {
    components: {
        CardTitle,
        ChangeOverlay
    },
    data () {
        return {
            // テーブルのヘッダー
            headers: [
                { text: '', value: 'idName', align: 'center', sortable: false, width: '12%' },
                { text: '名前', value: 'family_name', sortable: false, width: '8%' },
                { text: '', value: 'given_name', sortable: false, width: '8%' },
                { text: 'メールアドレス', value: 'email', sortable: false, width: '25%' },
                { text: '携帯番号', value: 'mobile_number', sortable: false, width: '8%' },
                { text: '会員区分', value: 'member_class', sortable: false, width: '8%' },
                { text: '来場実績', value: 'visited_code', sortable: false, width: '8%' },
                { text: '', value: 'Btn', sortable: false, width: '5%' }
            ],
            // セレクトボックス
            memberClassSelectItem: null,
            cellId: null,
            visitorClassSelectItem: [
                { code: 0, name: '予約済み' },
                { code: 1, name: '来場済み' },
                { code: 2, name: 'キャンセル' }
            ],
            representative: {
                email: '',
                mobile_number: '',
                era: '',
                family_name: '',
                given_name: '',
                profile: '',
                score_level: '',
                nickname: ''
            },
            classListArray: [{}],
            companionRegist: [],
            deleteCell: [],
            reserveType: null,
            // 予約番号 (仮親からもらう予定)
            reserveNo: null,
            email: '',
            mobile_number: '',
            groupNum: null,
            memberNo: null,
            playerMin: null,
            received: null,
            deleteCompanionDialog: false,
            processing: false,
            changeOverlay: false,
            // エラーメッセージ
            error: '',
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            loadingCount: 0,
            result: 0,
            sendFlag: true
        };
    },
    created () {
        this.Initialize();
    },
    watch: {
        deleteCell: function (val) {
            if (val.length >= 1) {
                this.companionRegist.map(el => {
                    if (val.includes(el.cell_id)) {
                        for (let player of el.players) {
                            player.disableFlag = true;
                            player.visitedDisableFlag = true;
                        }
                    // チェックを外した時
                    } else {
                        for (let player of el.players) {
                            if (player.member_no) {
                                player.disableFlag = true;
                            } else {
                                player.disableFlag = false;
                            }
                            player.visitedDisableFlag = false;
                        }
                    }
                });
            }
        }
    },
    methods: {
        async Initialize () {
        },
        /** ----------------------------------------------
         * ログインユーザー情報取得
         * ---------------------------------------------- */
        GetMyProfile: function () {
            var me = this;
            try {
                this.loadingOn();
                this.$apollo.mutate({
                    mutation: GET_MEMBER_PROFILE,
                    variables: {
                        member_no: this.received.memberNo
                    }
                }).then(res => {
                    me.representative = res.data.getMyProfileFromAdmin.Profile[0];
                    this.loadingOff();
                });
            } catch (error) {
                me.error = error;
            }
        },
        /** ----------------------------------------------
         * 同伴者入力項目チェック
         * @player 同伴者データ
         * ---------------------------------------------- */
        CheckCompanionValidater: function (player) {
            // メールの正規表現が誤りだったら
            if (player.email && !validater.checkMail(player.email)) {
                this.process.result = 1;
                this.process.resultText = this.$t('error.validation.mailFormat');
                this.changeOverlay = true;
                return false;
            // 携帯番号の正規表現が誤りだったら
            } else if (player.mobile_number && !validater.checkmobilenumberNoHyphen(player.mobile_number)) {
                this.process.result = 1;
                this.process.resultText = this.$t('error.validation.mobileNumber');
                this.changeOverlay = true;
                return false;
            // メールまたは携帯番号が入力されているのに性または名前が入力されていなかったら
            } else if ((player.email || player.mobile_number) && (!player.family_name && !player.given_name)) {
                this.process.result = 1;
                this.process.resultText = this.$t('error.validation.nameEmpty');
                this.changeOverlay = true;
                return false;
            // 名前が入力されているのに来場実績が設定されていなかったら
            } else if ((player.family_name || player.given_name) && player.visited_code === null) {
                this.process.result = 1;
                this.process.resultText = this.$t('error.validation.visitedCodeEmpty');
                this.changeOverlay = true;
            // 名前が入力されているのに会員区分が設定されていなかったら
            } else if ((player.family_name || player.given_name) && player.member_class === null) {
                this.process.result = 1;
                this.process.resultText = this.$t('error.validation.memberClassEmpty');
                this.changeOverlay = true;
            // 問題無ければ
            } else {
                return true;
            }
        },
        /** ----------------------------------------------
         * 同伴者に代表者がいるかチェック
         * ---------------------------------------------- */
        CheckRepresentativeEmail: function (data) {
            var checkFlag = true;
            for (var i = 0; i < data.length; i++) {
                if (data[i].email === this.representative.email) {
                    checkFlag = false;
                }
            }
            return checkFlag;
        },
        DuplicationEmailCheck (data) {
            var s = [];
            for (let obj of data) {
                if (obj.email) {
                    s.push(obj.email);
                }
            }
            var d = new Set(s);
            return d.size !== s.length;
        },
        /** ----------------------------------------------
         * 同伴者登録
         * ---------------------------------------------- */
        MakeUpdateCompanionList: async function () {
            var me = this;
            this.processing = true;
            var deleteCellList = [];
            for (let deletes of me.deleteCell) {
                if (Number(deletes) >= 1) {
                    deleteCellList.push(Number(deletes));
                }
            }
            let data = [];
            var classNo = 0;
            var id = 1;
            for (let frame of me.companionRegist) {
                if (!deleteCellList.includes(frame.cell_id)) {
                    classNo++;
                    for (let player of frame.players) {
                        let obj = {};
                        if (!this.CheckCompanionValidater(player)) {
                            return;
                        }
                        // 名前が入力されていれば
                        if (player.family_name || player.given_name) {
                            // 取得されていた情報と一致(変更はされていない)していればchange_flagを0にする
                            if ((player.family_name === player.old_family_name) &&
                                (player.given_name === player.old_given_name) &&
                                (player.email === player.old_email) &&
                                (player.member_class === player.old_member_class) &&
                                (player.reserve_no === me.reserveNo) &&
                                (player.clearFlag === false)) {
                                obj = {
                                    reserve_no: player.reserve_no,
                                    cell_id: frame.cell_id,
                                    class_no: classNo,
                                    player_no: id,
                                    family_name: player.family_name,
                                    given_name: player.given_name,
                                    email: player.email,
                                    mobile_number: player.mobile_number,
                                    gender: player.gender,
                                    era: player.era,
                                    profile: player.profile,
                                    score_level: player.score_level,
                                    enthusiasm: player.enthusiasm,
                                    nickname: player.nickname,
                                    member_class: player.member_class,
                                    visited_code: player.visited_code,
                                    member_no: player.member_no,
                                    change_flag: 0,
                                    send_play_together_email_flag: Number(this.sendFlag),
                                    reserve_type: me.reserveType
                                };
                                data.push(obj);
                            // 追加されていればchange_flagを1にする
                            } else if (player.clearFlag === true) {
                                obj = {
                                    reserve_no: me.reserveNo,
                                    cell_id: frame.cell_id,
                                    class_no: classNo,
                                    player_no: id,
                                    family_name: player.family_name,
                                    given_name: player.given_name,
                                    email: player.email,
                                    mobile_number: player.mobile_number,
                                    gender: 0,
                                    era: null,
                                    profile: null,
                                    score_level: null,
                                    enthusiasm: null,
                                    nickname: null,
                                    member_class: player.member_class,
                                    visited_code: player.visited_code,
                                    member_no: player.member_no,
                                    change_flag: 0,
                                    send_play_together_email_flag: Number(this.sendFlag),
                                    reserve_type: me.reserveType
                                };
                                data.push(obj);
                            // 取得されていた情報と一致しなければ(変更された)change_flagを2にする
                            } else if (((player.family_name !== player.old_family_name) ||
                                (player.given_name !== player.old_given_name) ||
                                (player.email !== player.old_email) ||
                                (player.member_class !== player.old_member_class)) &&
                                (player.reserve_no === me.reserveNo)) {
                                obj = {
                                    reserve_no: player.reserve_no,
                                    cell_id: frame.cell_id,
                                    class_no: classNo,
                                    player_no: id,
                                    family_name: player.family_name,
                                    given_name: player.given_name,
                                    email: player.email,
                                    mobile_number: player.mobile_number,
                                    gender: 0,
                                    era: null,
                                    profile: null,
                                    score_level: null,
                                    enthusiasm: null,
                                    nickname: null,
                                    member_class: player.member_class,
                                    visited_code: player.visited_code,
                                    member_no: player.member_no,
                                    change_flag: 0,
                                    send_play_together_email_flag: Number(this.sendFlag),
                                    reserve_type: me.reserveType
                                };
                                data.push(obj);
                            }
                            id++;
                        }
                        obj = null;
                    }
                }
                id = 1;
            }

            if (this.DuplicationEmailCheck(data) === true) {
                this.process.result = 1;
                this.process.resultText = '同じメールアドレスが指定されています。';
                this.changeOverlay = true;
                return;
            }
            if (!data) {
                this.process.result = 1;
                this.process.resultText = '組が全て削除されています。';
                this.changeOverlay = true;
                return;
            }

            if (this.CheckRepresentativeEmail(data)) {
                this.process.result = 1;
                this.process.resultText = '代表者が入力されていません。';
                this.changeOverlay = true;
                return;
            }
            // 予約番号がソートされた配列を作成する
            let reserveList = data.reduce((p, x) =>
                (p.indexOf(x.reserve_no) !== -1) ? p : [ ...p, x.reserve_no ], []);
            let reserves = [];
            // 予約番号ごとにカウントをする
            for (var i = 0; i < reserveList.length; i++) {
                reserves.push({ reserve_no: null, player_number: 0 });
                for (var j = 0; j < data.length; j++) {
                    if (reserveList[i] === data[j].reserve_no) {
                        reserves[i].reserve_no = data[j].reserve_no;
                        reserves[i].player_number = reserves[i].player_number + 1;
                    }
                }
            }

            // cellIDごとに配列をソートする
            let cells = data.reduce((p, x) =>
                (p.indexOf(x.cell_id) !== -1) ? p : [ ...p, x.cell_id ], []);

            // cellidごとの人数をカウント
            var cellPlayerNumber = this.cellsCountPlayerNumber(data, cells);

            if (cells.length !== Number(this.groupNum)) {
                this.process.result = 1;
                this.process.resultText = '変更組数は' + this.groupNum + '組です。';
                this.changeOverlay = true;
                return;
            }
            if ((this.companionRegist.length - deleteCellList.length) !== Number(this.groupNum)) {
                this.process.result = 1;
                this.process.resultText = '変更組数は' + this.groupNum + '組です。';
                this.changeOverlay = true;
                return;
            }
            if (this.CheckMinNumber(cellPlayerNumber)) {
                this.process.result = 1;
                this.process.resultText = '一組の最小人数が' + this.received.playerMin + '名以上のためプレーヤを入力してください。';
                this.changeOverlay = true;
                return;
            }

            // 予約変更
            await me.ReserveUpdate(data, cells, cellPlayerNumber);

            // 同伴者登録
            me.UpdateCompanion(data, reserves);
        },
        /** ----------------------------------------------
         * 削除cellリストチェック
         * ---------------------------------------------- */
        selectDeleteCell: function (cell) {
            if (this.deleteCell.length >= 1) {
                if (this.deleteCell.includes(cell)) {
                    this.deleteCell.forEach((el, index) => {
                        if (el === cell) {
                            this.deleteCell.splice(index, 1);
                        }
                    });
                } else {
                    this.deleteCell.push(cell);
                }
            } else {
                this.deleteCell.push(cell);
            }
        },
        /** ----------------------------------------------
         * 最小予約人数チェック
         * ---------------------------------------------- */
        CheckMinNumber: function (data) {
            for (let number of data) {
                if (number < this.received.playerMin) {
                    return true;
                }
            }
            return false;
        },
        /** ----------------------------------------------
         * cellidごとの人数をカウント
         * @data 同伴者データ
         * ---------------------------------------------- */
        cellsCountPlayerNumber: function (data, cells) {
            var cellPlayerNumber = [];
            for (var i = 0; i < cells.length; i++) {
                cellPlayerNumber.push(0);
                for (var j = 0; j < data.length; j++) {
                    if (cells[i] === data[j].cell_id) {
                        cellPlayerNumber[i] = cellPlayerNumber[i] + 1;
                    }
                }
            }
            return cellPlayerNumber;
        },
        /** ----------------------------------------------
        * 予約更新
        * @data 同伴者データ
        * @cells cell_idの配列
        * ---------------------------------------------- */
        ReserveUpdate: async function (data, cells, numbers) {
            try {
                this.$apollo.mutate({
                    mutation: REGIST_RESERVE_DELETE_CELL,
                    variables: {
                        golf_group_code: process.env.MIX_GROUP_CODE,
                        member_no: this.received.memberNo,
                        golf_code: this.received.golfCode,
                        plan_id: this.received.planId,
                        play_date: this.received.playDate,
                        cell_number: this.received.groupNum,
                        play_number: data.length,
                        reserve_type: this.received.reserveType,
                        cell_id: cells,
                        cell_player_number: numbers,
                        contact_tel: this.received.telephone,
                        request_first_choice: null,
                        request_second_choice: null,
                        request_third_choice: null,
                        request_contact_info: null,
                        reserve_no: this.received.reserveNo
                    }
                }).then(res => {
                    this.result = res;
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 同伴者登録
         * @data 同伴者データ
         * @reserves 予約番号のリスト
         * ---------------------------------------------- */
        UpdateCompanion: function (data, reserves) {
            var me = this;
            this.$apollo.mutate({
                mutation: UPDATE_COMPANION,
                variables: {
                    CompanionList: data,
                    ReserveNumbers: reserves
                }
            }).then(res => {
                me.MakeMailSendObject(data);
                me.companionRegist = [];
                me.deleteCell = [];
                me.deleteCompanionDialog = false;
                this.$emit('close-companion');
            }).catch(err => {
                me.process.result = 1;
                me.process.resultText = this.$t('result.error.change');
                me.changeOverlay = true;
                me.processing = false;
                me.error = err;
            });
        },
        /** ----------------------------------------------
         * メール送信用オブジェクト作成
         * ---------------------------------------------- */
        MakeMailSendObject: async function (data) {
            var me = this;
            var reserveEmailData = [];
            var startTime = [];
            for (let cell of me.companionRegist) {
                startTime.push(cell.time);
            }
            if (me.sendFlag) {
                for (let player of data) {
                    if (player.email && player.reserve_no === me.reserveNo) {
                        let reserveEmailObj = {
                            email: player.email,
                            mobile_number: player.mobile_number,
                            reserve_no: me.reserveNo,
                            family_name: player.family_name,
                            given_name: player.given_name,
                            start_time: startTime,
                            point: null,
                            edit_flag: true
                        };
                        reserveEmailData.push(reserveEmailObj);
                    }
                }
                // メール送信用のメソッドを実行する
                if (reserveEmailData) {
                    me.CompleteReserveEmailSend(reserveEmailData);
                }
            }
        },
        /** ----------------------------------------------
         * 予約完了メール送信
         * @data メール送信用オブジェクト
         * ---------------------------------------------- */
        CompleteReserveEmailSend: async function (data) {
            try {
                await this.$apollo.mutate({
                    mutation: COMPLETE_RESERVE_EMAIL,
                    variables: {
                        ReserveEmail: data
                    }
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * email入力時の会員区分取得
         * @frameId 枠のID
         * @playerId プレイヤーID
         * @email 入力されたメールアドレス
         * ---------------------------------------------- */
        GetEmailSearchMemberClass (frameId, playerId, email) {
            this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_EMAIL_SEARCH_MEMBER_CLASS,
                variables: {
                    email: email,
                    golf_group_code: process.env.VUE_APP_GROUP_CODE
                }
            }).then(res => {
                frameId--;
                playerId--;
                this.companionRegist[frameId].players[playerId].member_class = res.data.GetEmailSearchMemberClass.member_class;
                this.companionRegist.splice();
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * クリアボタンを押下
         * @frameId 枠のID
         * @playerId プレイヤーID
         * ---------------------------------------------- */
        PushClearButton: function (frameId, playerId, email) {
            var me = this;
            frameId--;
            playerId--;
            me.companionRegist[frameId].players[playerId].member_no = null;
            me.companionRegist[frameId].players[playerId].family_name = null;
            me.companionRegist[frameId].players[playerId].given_name = null;
            me.companionRegist[frameId].players[playerId].email = null;
            me.companionRegist[frameId].players[playerId].mobile_number = null;
            me.companionRegist[frameId].players[playerId].member_class = null;
            me.companionRegist[frameId].players[playerId].visited_code = null;
            me.companionRegist[frameId].players[playerId].clearFlag = true;
            me.companionRegist[frameId].players[playerId].disableFlag = false;
        },
        /** ----------------------------------------------
         * ダイアログを開く
         * @reserveNo 親からもらってくる予約番号
         * ---------------------------------------------- */
        OpenDialog: async function (reserveNo, editingProhibited, groupNum, received) {
            this.deleteCell = [];
            this.createCompanionList();
            this.reserveNo = reserveNo;
            this.received = received;
            this.groupNum = groupNum;
            this.GetCompanionList(editingProhibited);
            this.GetFlagCodeList();
            this.GetMyProfile();
        },
        /** ----------------------------------------------
         * ダイアログを閉じる
         * ---------------------------------------------- */
        CloseDialog: function () {
            this.companionRegist = [];
            this.deleteCell = [];
            this.$emit('close-companion');
            this.deleteCompanionDialog = false;
        },
        /** ----------------------------------------------
         * 同伴者配列を作成
         * ---------------------------------------------- */
        createCompanionList: function () {
            var id = this.companionRegist.length + 1;
            var companions = {
                id: id,
                course_name: null,
                time: null,
                cell_id: null,
                players: [
                    {
                        id: 1,
                        idName: 'プレーヤー1',
                        member_no: null,
                        family_name: null,
                        given_name: null,
                        email: null,
                        mobile_number: null,
                        enthusiasm: null,
                        member_class: null,
                        visited_code: null,
                        clearFlag: true,
                        disableFlag: false,
                        visitedDisableFlag: false,
                        clearButtonDisableFlag: false
                    },
                    {
                        id: 2,
                        idName: 'プレーヤー2',
                        member_no: null,
                        family_name: null,
                        given_name: null,
                        email: null,
                        mobile_number: null,
                        enthusiasm: null,
                        member_class: null,
                        visited_code: null,
                        clearFlag: true,
                        disableFlag: false,
                        visitedDisableFlag: false,
                        clearButtonDisableFlag: false
                    },
                    {
                        id: 3,
                        idName: 'プレーヤー3',
                        member_no: null,
                        family_name: null,
                        given_name: null,
                        email: null,
                        mobile_number: null,
                        enthusiasm: null,
                        member_class: null,
                        visited_code: null,
                        clearFlag: true,
                        disableFlag: false,
                        visitedDisableFlag: false,
                        clearButtonDisableFlag: false
                    },
                    {
                        id: 4,
                        idName: 'プレーヤー4',
                        member_no: null,
                        family_name: null,
                        given_name: null,
                        email: null,
                        mobile_number: null,
                        enthusiasm: null,
                        member_class: null,
                        visited_code: null,
                        clearFlag: true,
                        disableFlag: false,
                        visitedDisableFlag: false,
                        clearButtonDisableFlag: false
                    }
                ]
            };

            this.companionRegist.push(companions);
        },
        /** ----------------------------------------------
         * 予約状況取得
         * ---------------------------------------------- */
        GetCompanionList: async function (editingProhibited) {
            var me = this;
            me.loadingOn();
            try {
                var result = await this.$apollo.query({
                    query: GET_RESERVE_TYPE,
                    fetchPolicy: 'no-cache',
                    variables: {
                        reserve_no: me.reserveNo
                    }
                });
                me.reserveType = result.data.GetReserveTypeFromAdmin.reserveTypeList[0].reserve_type;
                me.memberNo = result.data.GetReserveTypeFromAdmin.reserveTypeList[0].member_no;
                me.playerMin = result.data.GetReserveTypeFromAdmin.reserveTypeList[0].player_min;
                // 予約種別によって検索条件用の変数を変える
                if (result.data.GetReserveTypeFromAdmin.reserveTypeList[0].reserve_type === CODE_MASTER.RESERVE_TYPE_NORMAL) {
                    me.cellId = null;
                } else if (result.data.GetReserveTypeFromAdmin.reserveTypeList[0].reserve_type === CODE_MASTER.RESERVE_TYPE_SHARE) {
                    me.cellId = result.data.GetReserveTypeFromAdmin.reserveTypeList[0].cell_id;
                }
                this.$apollo.query({
                    query: GET_COMPANION_LIST,
                    fetchPolicy: 'no-cache',
                    variables: {
                        cell_id: me.cellId,
                        reserve_no: me.reserveNo
                    }
                }).then(res => {
                    var companionListArray = res.data.GetCompanionListFromAdmin.CompanionLists;
                    var classListArray = res.data.GetCompanionListFromAdmin.ClassList;
                    me.sendFlag = Boolean(classListArray[0].send_play_together_email_flag);
                    // classListArray分入力欄を作成する
                    for (var j = 0; j < classListArray.length; j++) {
                        if (j !== 0) {
                            me.createCompanionList();
                        }
                        me.companionRegist[j].course_name = classListArray[j].course_name;
                        me.companionRegist[j].time = classListArray[j].play_start.slice(0, -3);
                        me.companionRegist[j].cell_id = classListArray[j].cell_id;
                    }
                    me.MakerRegistCompanionList(companionListArray, editingProhibited);
                    me.loadingOff();
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * 表示する同伴者一覧作成
         * ---------------------------------------------- */
        MakerRegistCompanionList: function (companionListArray, editingProhibited) {
            var me = this;
            if (companionListArray.length >= 1) {
                for (let list of me.companionRegist) {
                    for (let player of list.players) {
                        companionListArray.map(el => {
                            if (list.id === el.class_no && player.id === el.player_no) {
                                player.reserve_no = el.reserve_no;
                                player.cell_id = el.cell_id;
                                player.family_name = el.family_name;
                                player.given_name = el.given_name;
                                player.email = el.email;
                                player.mobile_number = el.mobile_number;
                                player.old_family_name = el.family_name;
                                player.old_given_name = el.given_name;
                                player.old_email = el.email;
                                player.old_mobile_number = el.old_mobile_number;
                                player.gender = el.gender;
                                player.era = el.era;
                                player.profile = el.profile;
                                player.score_level = el.score_level;
                                player.enthusiasm = el.enthusiasm;
                                player.nickname = el.nickname;
                                player.visited_code = el.visited_code;
                                player.member_no = el.member_no;
                                player.clearFlag = false;
                                // 会員区分がなかったらビジターにする
                                if (el.member_class === null) {
                                    player.member_class = CODE_MASTER.MEMBER_CLASS_VISITOR;
                                    player.old_member_class = CODE_MASTER.MEMBER_CLASS_VISITOR;
                                } else {
                                    player.member_class = el.member_class;
                                    player.old_member_class = el.member_class;
                                }
                                // 会員なら編集できなくする
                                if (el.member_no) {
                                    player.disableFlag = true;
                                }
                                // 予約者のクリアボタンを非活性にする
                                if (player.member_no === me.memberNo) {
                                    player.clearButtonDisableFlag = true;
                                    me.email = player.email;
                                } else {
                                    player.clearButtonDisableFlag = false;
                                }
                                // 予約番号の不一致でシェア予約と判断し編集できないようにする
                                if (player.reserve_no !== me.reserveNo || editingProhibited) {
                                    player.clearButtonDisableFlag = true;
                                    player.disableFlag = true;
                                }
                            }
                        });
                    }
                }
            }
            me.changeVisitCodeOnly(editingProhibited);
        },
        /** --------------------------------------------
        * 来場実績だけ変更可能
        * -------------------------------------------- */
        changeVisitCodeOnly: function (editingProhibited) {
            var me = this;
            if (editingProhibited) {
                for (let list of me.companionRegist) {
                    for (let player of list.players) {
                        if (player.given_name === null && player.family_name === null && player.email == null) {
                            player.clearButtonDisableFlag = true;
                            player.disableFlag = true;
                            player.visitedDisableFlag = true;
                        }
                    }
                }
            }
        },
        /** --------------------------------------------
        * コードリスト取得(会員区分)
        * -------------------------------------------- */
        GetFlagCodeList: async function () {
            var me = this;
            me.loadingOn();
            try {
                this.$apollo.query({
                    query: GET_CODE_KEY_LIST,
                    fetchPolicy: 'no-cache',
                    variables: {
                        codeKeyList: ['member_class']
                    }
                }).then(res => {
                    me.memberClassSelectItem = res.data.GetCodeListByKeys.CodeKeyRecList[0].codeRec;
                    me.loadingOff();
                });
            } catch (error) {
                this.error = error;
            }
        },
        /** ----------------------------------------------
         * ローディング開始
         * ---------------------------------------------- */
        loadingOn: function () {
            this.loadingCount++;
        },
        /** ----------------------------------------------
         * ローディング終了
         * ---------------------------------------------- */
        loadingOff: function () {
            this.loadingCount--;
            if (this.loadingCount === 0) {
                this.deleteCompanionDialog = true;
            }
        }
    }
};

</script>

<style scoped>

.margin_buttom20{
    margin-top: 50px;
}

.frame_name{
    padding-left: 2%;
}

.space{
    margin-left: 1rem;
}
.fontsize-1_5rem{
    font-size: 1.5rem;
    font-weight: bold;
}

</style>
